import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {Link} from 'react-router-dom';

import logoImage from '../images/logo.png';

import './header.scss';

class Header extends Component {
  render() {
		const { props } = this;
		return (
			<header className="header">
					<div className="logo-area">
						<a href="/">
							<img src={logoImage} style={{
								height: 40,
								padding: 0,
								margin: 0,
							}} />
						</a>
					</div>
					<div className="navigation">
					<ul className="menu">
							<li><Link to="/auth/signout">Sign Out</Link></li>
							{props.admin ? (
								<span>
									{/*<li><Link to="/validation">Validation</Link></li>*/}
									<li><Link to="/admin/jobs">Manage Jobs</Link></li>
									<li><Link to="/organizations">Organizations</Link></li>
									<li><Link to="/apps">Apps</Link></li>
								</span>
							): null}
							<li><Link to="/loadNextJob">Job Queue</Link></li>
						</ul>
					</div>
				</header>
    );
  }
}

Header.propTypes = {
	admin: PropTypes.bool,
};

Header.defaultProps = {
	admin: false,
}

export default Header;


// WEBPACK FOOTER //
// ./src/shared/components/Header.js